import React from "react";
import {Button, Modal} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";
import useCustomTranslation from "core/customTranslation";
import TableParamsDD from "./TableParamsDD";
import translations from "./translations";
import TableNfcReport from "./TableNfcReport";

const DeviceParamsModal = ({isOpen, setIsOpen, device, type}) => {
    const {t: _TC} = useCustomTranslation(translations);
    const {t: _Tf} = useTranslation("forms");

    const onClose = () => {
        setIsOpen(false);
    };

    const renderFormByModel = () => {
        switch (type) {
            case "dd":
                return <TableParamsDD device={device} />;
            case "nfc":
                return <TableNfcReport device={device} />;
            default:
                return <></>;
        }
    };

    return (
        <Modal show={isOpen} onHide={onClose} size="lg" animation={true} centered={true} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{type === "dd" ? _TC("deviceddparams") : _TC("devicenfc_report")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="deviceParams">{renderFormByModel()}</Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    {_Tf("labels.close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeviceParamsModal;
